import * as React from 'react';

import {getFormattedMessage} from 'features/services/utils/language-helper';

import './style.scss';

import { Facts } from '.';
import { QuickFactsItem } from './item';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- viewModel varies by page type
    viewModel: any;
}

export const AboutUsQuickFacts: React.FunctionComponent<Props> = ({ viewModel }) => {
    const facts : Facts[] = [
        {key: 'buildingRights', devCounter: '01', 
            label: getFormattedMessage('jm.components.QuickFacts.corporate.buildingRights'), 
            fact: viewModel.availableBuildingRights, 
            condition: viewModel.availableBuildingRights 
        },
        {key: 'certificates', devCounter: '02', 
            label: getFormattedMessage('jm.components.QuickFacts.corporate.certificates'), 
            fact: viewModel.certificates, 
            condition: viewModel.certificates 
        },
        {key: 'employees', devCounter: '03', 
            label: getFormattedMessage('jm.components.QuickFacts.corporate.employees'), 
            fact: viewModel.employees, 
            condition: viewModel.employees 
        },
        {key: 'founded', devCounter: '04', 
            label: getFormattedMessage('jm.components.QuickFacts.corporate.founded'), 
            fact: viewModel.founded, 
            condition: viewModel.founded 
        },
        {key: 'markets', devCounter: '05', 
            label: getFormattedMessage('jm.components.QuickFacts.corporate.markets'), 
            fact: viewModel.market, 
            condition: viewModel.market 
        },
        {key: 'revenue', devCounter: '06', 
            label: getFormattedMessage('jm.components.QuickFacts.corporate.revenue'), 
            fact: viewModel.revenue, 
            condition: viewModel.revenue 
        },
    ];

    const renderFactsByOrder = (factOrder: string[]) => {
        return factOrder.map((key, index) => {
            const fact = facts.find(f => f.key === key);
            if (!fact || !fact.condition) return null;

            return (
                <QuickFactsItem
                    key={fact.key}
                    index={index.toString()}
                    devCounter={fact.devCounter}
                    itemLabel={fact.label}
                    itemFact={fact.fact}
                />
            );
        })
        .filter(Boolean);
    };

    const order = [
        'markets',
        'revenue',
        'founded',
        'employees',
        'buildingRights',
        'certificates',
    ];

    return (
        <div className="quick-facts__box">
            <dl className="quick-facts__list">
                {renderFactsByOrder(order)}
            </dl>
        </div>
    );
};
